const EntityFormModalTestIdsScope = {
  ENTITY_FORM_MODAL: 'entity-form-modal',
};

export const EntityFormModalTestIds = {
  MODAL: `${EntityFormModalTestIdsScope.ENTITY_FORM_MODAL}.modal`,
  CONTENT: `${EntityFormModalTestIdsScope.ENTITY_FORM_MODAL}.content`,
};
